import { AppLoader } from "components";
import { Sidebar, ChatWidget, useProfile } from "modules/common";
import { Outlet } from "react-router-dom";

import styles from "./MainLayout.module.scss";

const MainLayout = () => {
  const { isLoading, isError } = useProfile();

  if (isLoading || isError) return <AppLoader />;

  return (
    <div className={styles["main-layout"]}>
      <div className={styles["main-layout__sidebar"]}>
        <Sidebar />
      </div>
      <div className={styles["main-layout__content"]}>
        <Outlet />
        <ChatWidget />
      </div>
    </div>
  );
};

export default MainLayout;
